module.exports = __webpack_public_path__ + "img/img47.e950224c.svg";